import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { CallPermissionView } from '../CallPermissionView/CallPermissionView';
import { useCallPermissionPresenter } from './CallPermission.presenter';
import { ICallPermissionProps } from './CallPermission.types';

export const CallPermission: FC<ICallPermissionProps> = observer((props) => {
  const presenter = useCallPermissionPresenter(props);

  return (
    <CallPermissionView
      permissionValue={presenter.permissionValue}
      permissionLabel={presenter.permissionLabel}
      onClick={presenter.onPermissionClick}
    />
  );
});
